export const AUTH = {
  LOGIN: "LOGIN",
  GENERATE_TOKEN: "GENERATE_TOKEN",
  LOGOUT: "LOGOUT",
  VERSION: "VERSION",
};

export const OTP = {
  GENERATE_OTP_AGENT: "GENERATE_OTP_AGENT",
  VERIFY_OTP_AGENT: "VERIFY_OTP_AGENT",
  GENERATE_OTP_REF: "GENERATE_OTP_REF",
  VERIFY_OTP_REF: "VERIFY_OTP_REF",
};

export const AGENT = {
  CREATE: "AGENT_ADD",
  AGREE_TNC: "AGREE_TNC",
};

export const REFERRER = {
  INDEX: "REFERRER_LIST",
  DETAIL: "REFERRER_DETAIL",
  REFERRER_TERMINATED: "REFERRER_TERMINATED",
  CREATE: "REFERRER_ADD",
  EDIT: {
    "02": "REFERRER_EDIT_WAITING",
    "03": "REFERRER_EDIT_REGISTERED",
  },
  CREATE_TERMINATED: "REFERRER_TERMINATED_ADD",
  AGREE_TNC_REF: "AGREE_TNC_REF",
  CHANGE_PWD: "CHANGE_PWD",
  FORGOT_PWD: "FORGOT_PWD",
  FILE: "REFERRER_FILE",
  UPDT_OTP_FLAG: "REFERRER_UPDATE_OTP_FLAG",
};

export const LEADS = {
  INDEX: "LEADS_LISTING",
  CREATE: "LEADS_ADD",
  LEADS_DOWNLOAD: "LEADS_DOWNLOAD",
  PAYMENT_HISTORY: "PAYMENT_HISTORY",
  PAYMENT_HISTORY_CALCULATE: "PAYMENT_HISTORY_CALCULATE",
  PAYMENT_HISTORY_PER_LEAD: "PAYMENT_HISTORY_PER_LEAD",
  PAYMENT_HISTORY_CALCULATE_PER_LEAD: "PAYMENT_HISTORY_CALCULATE_PER_LEAD",
  PAYMENT_HISTORY_DOWNLOAD: "PAYMENT_HISTORY_DOWNLOAD",
  PAYMENT_HISTORY_PER_LEAD_DOWNLOAD: "PAYMENT_HISTORY_PER_LEAD_DOWNLOAD",
};

export const COMMON = {
  NEEDS: "NEEDS",
  TNC_AGENT: "TNC_AGENT",
  TNC_REFERRER: "TNC_REFERRER",
  TNC_DOWNLOAD: "TNC_DOWNLOAD",
  MASTER_BANK: "MASTER_BANK",
  MASTER_COUNTRIES: "MASTER_COUNTRIES",
};

export const DOCUMENT = {
  INDEX: "DOCUMENT",
  DOCUMENT_DOWNLOAD: "DOCUMENT_DOWNLOAD",
};

export const NEWS = {
  INDEX: "NEWS",
};

export const DRAFT = {
  INDEX: "DRAFT_LIST",
  DELETE: "DRAFT_DELETE",
  ADD: "DRAFT_ADD",
};

export const CAPTCHA = {
  VERIFY: "VERIFY_CAPTCHA",
  VERIFY_V2: "VERIFY_CAPTCHA_V2",
};
